import withReadingPercentage from '@components/ReadingPercentage/withReadingPercentage'
import type { TiptapViewerAcceptProps } from './interface'
import TiptapViewer from './TiptapViewer'
import { withTiptapViewer } from './withTiptapViewer'

const ConnectedTiptapViewer = withReadingPercentage<TiptapViewerAcceptProps>(
  withTiptapViewer(TiptapViewer)
)

export { ConnectedTiptapViewer as TiptapViewer }
